import { IState } from '../interface/interface';
import {
    ADD_VIDEO, UPDATE_LIST, GET_INFO, GET_CHANNEL_INFO, ADD_USER,
    GET_LISTS_INFO, GET_ONE_LIST,
} from "./constants";

const initialState = {
    listVideos: {
        listId: '',
        name: '',
        description: '',
        createBy: '',
        videos: []
    },
    listLists: [],
    infoApi: {},
    channelInfoApi: {},
    user: {
        name: '',
        email: '',
        image: '',
        userId: '',
    }
}

type Action = { type: string, payload: any }

export const Reducer = (state: IState = initialState, action: Action) => {
    // console.log(action.type, 'tipo de acción')
    switch (action.type) {
        case ADD_USER:
            // console.log('llega al reducer channelInfo', action.payload);
            return { ...state, user: action.payload }

        case ADD_VIDEO:
            // console.log(action.payload, 'en el reducer');
            return {
                ...state, listVideos: {
                    ...state.listVideos, videos: [
                        ...state.listVideos.videos].concat([action.payload])
                }
            }

        case UPDATE_LIST:
            // console.log(action, 'UPDATE LIST el array de objetos en el reducer');
            return {
                ...state, listVideos: {
                    ...state.listVideos, videos: action.payload
                }
            }

        case GET_INFO:
            // console.log('llega al reducer', action.payload);
            return { ...state, infoApi: action.payload }

        case GET_CHANNEL_INFO:
            // console.log('llega al reducer channelInfo', action.payload);
            return { ...state, channelInfoApi: action.payload }

        case GET_LISTS_INFO:
            // console.log('llega al reducer listsInfo', action.payload);
            return { ...state, listLists: action.payload }

        case GET_ONE_LIST:
            // console.log('llega al reducer one list video', action.payload);
            return {
                ...state, listVideos: action.payload
            }

        default:
            return state;
    }
}


